import { render, staticRenderFns } from "./my_course.vue?vue&type=template&id=7e4a28ee&"
import script from "./my_course.vue?vue&type=script&lang=js&"
export * from "./my_course.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports